import React from 'react';
import { AdjustmentBucket } from 'model/salesDashboard';
import { AdjustmentBucketChart } from '../Common/AdjustmentBucketChart';

interface ForfeiteDepositsChartProps {
    data?: AdjustmentBucket;
    isLoading?: boolean;
}

export const ForfeiteDepositsChart: React.FC<ForfeiteDepositsChartProps> = ({ data, isLoading }) => (
    <AdjustmentBucketChart
        data={data}
        isLoading={isLoading}
        title="Forfeited deposits"
    />
);
